import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HelpContentComponent } from '../../../../../UI-Lib/Help-Tooltip';

export interface ParcelTileTaxableValuesComponentParams {
    taxableValues: Core.ParcelTileTaxableValue[];
}

@Component({
    selector: 'parcel-tile-taxable-values-tooltip',
    templateUrl: './parcelTileTaxableValues.component.html',
    imports: [CommonModule],
})
export class ParcelTileTaxableValuesTooltipComponent  implements HelpContentComponent<ParcelTileTaxableValuesComponentParams> {
    constructor() { }

    params: ParcelTileTaxableValuesComponentParams;

    taxableValues: Core.ParcelTileTaxableValue[] = [];

    helpInit(params: ParcelTileTaxableValuesComponentParams) {
        this.taxableValues = params?.taxableValues || [];
    }
}
